module.exports = "/_next/static/images/star-91b94959b4913c39a5990cd8d48ca216.png";